export default __webpack_public_path__ + "static/media/d12.8d764b24.png";